<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="soas">
      <!-- Search Begin -->
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="对账单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入对账单号" clearable/>
          </vm-search>
          <vm-search label="送货单号">
            <el-input v-model.trim="filter.purchaseReceiveNo" placeholder="请输入送货单号" clearable/>
          </vm-search>
          <vm-search label="采购单号">
            <el-input v-model.trim="filter.sapPurchaseOrderNo" placeholder="请输入采购单号" clearable/>
          </vm-search>
          <vm-search label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </vm-search>
          <vm-search label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </vm-search>
          <vm-search label="发票号码">
            <el-input v-model.trim="filter.invoiceNo" placeholder="请输入发票号码" clearable/>
          </vm-search>
          <vm-search label="节点">
            <el-select v-model="filter.statusName">
              <el-option label="全部" value=""/>
              <el-option label="草稿" value="草稿"/>
              <el-option label="采购经理审批" value="采购经理审批"/>
              <el-option label="采购确认开票申请" value="采购确认开票申请"/>
              <el-option label="供应商开票" value="供应商开票"/>
              <el-option label="采购确认发票信息" value="采购确认发票信息"/>
              <el-option label="财务确认发票信息" value="财务确认发票信息"/>
              <el-option label="已完成" value="已完成"/>
              <el-option label="作废" value="作废"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <!-- Search End -->
      <div slot="toolbar">
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
      </div>
      <el-table-column prop="billNo" align="center" width="100" label="对账单号">
        <template slot-scope="scope">
          <span style="cursor: pointer; color:#2d8cf0" @click="goToPreview(scope.row)">{{scope.row.billNo}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="billType" width="100" label="对账类型">
        <template v-slot="scope">
          <span v-if="scope.row.billType === 10">整单对账</span>
          <span v-if="scope.row.billType === 20">拆单对账</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="supplierName"
          align="center"
          label="供应商名称"
          min-width="150"
          show-overflow-tooltip/>
      <el-table-column
          prop="buyUserName"
          align="center"
          label="采购组"
          min-width="110"
          show-overflow-tooltip/>
      <el-table-column
          prop="creatorName"
          align="center"
          label="创建人"
          min-width="100"
          show-overflow-tooltip/>
      <el-table-column prop="submitTime" align="center" width="140" label="提交时间"/>
      <el-table-column prop="statusName" align="center" width="140" label="节点"/>
      <el-table-column prop="cloudSoaStatusName" align="center" width="140" label="云报账状态"/>
      <el-table-column prop="note" label="备注" width="160" show-overflow-tooltip/>
      <el-table-column prop="createTime" align="center" width="140" label="创建时间"/>
      <el-table-column
          v-if="editAuth"
          label="操作"
          align="center"
          fixed="right"
          width="280px">
        <template slot-scope="scope">
          <el-button type="success" :loading="updateStatusLoading" @click="updateCloudStatus(scope.row)">票税云同步</el-button>
          <el-button type="primary" :loading="submitLoading" :disabled="scope.row.status !== 0" @click="submitHandle(scope.row)">提交</el-button>
          <el-button type="danger" :disabled="scope.row.status !== 0 || submitLoading" @click="deleteHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <reconcile-order-edit ref="reconcileOrderEdit" @save-success="getList"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReconcileOrderEdit from "./ReconcileOrderEdit.vue";
  import LoginUtil from "@/util/loginUtil";

  export default {
    name:"ReconcileOrderList",
    components: { VmTable, VmSearch, ReconcileOrderEdit },
    data() {
      return {
        submitLoading:false,
        updateStatusLoading:false,
        editAuth: this.$auth(959),
        userType: LoginUtil.getUserType(),
        name: LoginUtil.getName(),
        exportLoading:false,
        filter: {
          billNo: "",
          supplierName: "",
          status: "",
          statusName:"",
          purchaseReceiveNo:"",
          sapPurchaseOrderNo:"",
          buyUserName:"",
        },
      };
    },

    mounted() {
      if (this.userType === 1) {
        this.filter.buyUserName = this.name;
      }
      this.getList(1);
    },

    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      // 删除未提交的对账单
      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "soas", row.pkId).then((res) => {
            if (res.success) {
              this.$message.success("删除成功");
              this.getList(1);
            }
          });
        });
      },

      goToPreview(row) {
        this.$router.push({
          path: "/ReconcileOrderDetail",
          query: {
            billType: 27,
            billId: row.pkId,
            sequId: -1,
            $tabName: "对账管理详情" + row.billNo,
          },
        });
      },  

      // 提交
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.submitLoading = true;
          this.$http.post("basic", `soas/submit/${row.pkId}`).then((res) => {
            if (res.success) {
              this.submitLoading = false;
              this.$message.success("提交成功");
              this.getList(1);
            }
          }).catch(()=>{
            this.submitLoading = false;
          });
        });
      },

      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "soas/exportList", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      updateCloudStatus(row) {
        this.updateStatusLoading=true;
        this.$http.get("basic", `soas/queryCloudStatus/${row.pkId}`)
          .then((res) => {
            this.$message.success("更新成功");
            this.getList(1);
          }).finally(()=>{
            this.updateStatusLoading=false;
          });
      },
    },
  };
</script>
